jQuery(document).ready(function($) {

    $( ".bloc_chiffres" ).each(function( index ) {

        var parent = $(this)

        // Sous 1024px les chiffres sont empilés loin sous l'intro : on déclenche
        // le compteur sur la grille elle-même, dès son entrée à l'écran, sinon
        // il se joue hors champ.
        var mobile = window.matchMedia("(max-width: 1023.98px)").matches
        var declencheur = mobile ? parent.find(".chiffres") : parent

        gsap.from( parent, {
            scrollTrigger: {
                trigger: declencheur,
                start: mobile ? "top 85%" : "top 40%",
                markers: false,
                once: true,
                onEnter: self => {

                    parent.find( ".chiffre .nb" ).each(function( index ) {

                        var nb = $(this).data("chiffre")
                        var $this = $(this)

                        jQuery({ Counter: 0 }).animate({ Counter: nb }, {
                            duration: 2000,
                            easing: 'swing',
                            step: function () {
                                $this.text(Math.ceil(this.Counter));
                            }
                        })

                    })

                }
            }

        })
    })

});
